// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._zulp1ejb{gap:var(--ds-space-300,24px)}
._zulpu2gc{gap:var(--ds-space-100,8px)}._10fp1h6o{justify-self:center}
._1e0c11p5{display:grid}
._1wpz1h6o{align-self:center}
._4cvr1h6o{align-items:center}
._6a6z1h6o{justify-items:center}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-datasource/dist/esm/ui/common/error-state/modal-loading-error.compiled.css"],"names":[],"mappings":";AACA,WAAW,4BAA4B;AACvC,WAAW,2BAA2B,CAAC,WAAW,mBAAmB;AACrE,WAAW,YAAY;AACvB,WAAW,iBAAiB;AAC5B,WAAW,kBAAkB;AAC7B,WAAW,oBAAoB","sourcesContent":["\n._zulp1ejb{gap:var(--ds-space-300,24px)}\n._zulpu2gc{gap:var(--ds-space-100,8px)}._10fp1h6o{justify-self:center}\n._1e0c11p5{display:grid}\n._1wpz1h6o{align-self:center}\n._4cvr1h6o{align-items:center}\n._6a6z1h6o{justify-items:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
